import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  mode: "history",
  routes: [
    {
      path: "/poiuytr", // 隐私协议
      name: "poiuytr",
      component: () => import("@/views/poiuytr/index.vue"),
      meta: {
        title: "Kebijakan Privasi Aplikasi DanaBaik",
      },

    },
    {
      path: "/qwertyu", // 权限披露
      name: "qwertyu",
      component: () => import("@/views/qwertyu/index.vue"),
      meta: {
        title: "Pernyataan Izin Aplikasi",
      },
    },
    {
      path: "/qxfrjsae", // 手动开启权限
      name: "qxfrjsae",
      component: () => import("@/views/qxfrjsae/index.vue"),
      meta: {
        title: "",
      },
    },
    {
      path: "/puytgbne", // 手动开启push教程
      name: "puytgbne",
      component: () => import("@/views/puytgbne/index.vue"),
      meta: {
        title: "",
      },
    },
    {
      path: '/down', //apk下载
      name: 'ApkDown',
      component: () => import('@/views/down/index.vue'),
    },
    {
      path: '/pwtxzopg', //IM
      name: 'pwtxzopg',
      component: () => import('@/views/pwtxzopg/index.vue'),
      meta: {
        title: "",
      },
    },
    // {
    //   path: "/yivcxn", // 投诉
    //   name: "Yivcxn",
    //   meta: {
    //     title: "Komplain",
    //   },
    //   component: () => import("@/views/yivcxn/index.vue"),
    // },
    // {
    //   path: "/vbfdsfd", // 投诉
    //   name: "vbfdsfd",
    //   component: () => import("@/views/vbfdsfd/index.vue"),
    // },
  ],
});

export default router;
